var _rect, _rect2, _path, _circle, _circle2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgProductPages(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 55,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 14.535,
    y: 6.618,
    width: 13.182,
    height: 7.909,
    rx: 2.197,
    transform: "rotate(-25.223 14.535 6.618)",
    fill: "#fff",
    stroke: "#525376",
    strokeWidth: 2.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 15.149,
    width: 20,
    height: 10,
    rx: 2.688,
    fill: "#fff",
    stroke: "#525376",
    strokeWidth: 2.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.09 50.023h20.225c.676 0 1.266-.69 1.266-1.615 0-.926-.59-1.616-1.266-1.616h-19.93c-.988 0-1.595-.861-1.75-2.175l-.278-2.261H33.35c2.53 0 3.83-1.938 4.194-5.018l2.387-11.393c.034-.28.069-.625.069-.818 0-1.034-.624-1.745-1.577-1.745H10.12l-.329-2.735c-.173-1.658-.659-2.498-2.426-2.498H1.283c-.694 0-1.283.754-1.283 1.615 0 .883.59 1.637 1.282 1.637H7.14l2.773 23.647c.364 3.058 1.664 4.975 4.177 4.975zm22.964-23.389l-2.23 10.316c-.14 1.335-.711 2.154-1.734 2.154l-21.114.021-1.473-12.49h26.55z",
    fill: "#525376"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 29.5,
    cy: 50.649,
    r: 2.25,
    fill: "#fff",
    stroke: "#525376",
    strokeWidth: 2.5
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 18.5,
    cy: 50.649,
    r: 2.25,
    fill: "#fff",
    stroke: "#525376",
    strokeWidth: 2.5
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDAiIGhlaWdodD0iNTUiIHZpZXdCb3g9IjAgMCA0MCA1NSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3QgeD0iMTQuNTM1MiIgeT0iNi42MTc1MiIgd2lkdGg9IjEzLjE4MjEiIGhlaWdodD0iNy45MDkyNiIgcng9IjIuMTk3MDIiIHRyYW5zZm9ybT0icm90YXRlKC0yNS4yMjM0IDE0LjUzNTIgNi42MTc1MikiIGZpbGw9IndoaXRlIiBzdHJva2U9IiM1MjUzNzYiIHN0cm9rZS13aWR0aD0iMi41Ii8+CjxyZWN0IHg9IjE0IiB5PSIxNS4xNDg3IiB3aWR0aD0iMjAiIGhlaWdodD0iMTAiIHJ4PSIyLjY4NzUiIGZpbGw9IndoaXRlIiBzdHJva2U9IiM1MjUzNzYiIHN0cm9rZS13aWR0aD0iMi41Ii8+CjxwYXRoIGQ9Ik0xNC4wOTAxIDUwLjAyMjlIMzQuMzE1NEMzNC45OTEzIDUwLjAyMjkgMzUuNTgwNiA0OS4zMzM3IDM1LjU4MDYgNDguNDA3NkMzNS41ODA2IDQ3LjQ4MTYgMzQuOTkxMyA0Ni43OTI0IDM0LjMxNTQgNDYuNzkyNEgxNC4zODQ3QzEzLjM5NjkgNDYuNzkyNCAxMi43OTAzIDQ1LjkzMDkgMTIuNjM0MyA0NC42MTcyTDEyLjM1NyA0Mi4zNTU5SDMzLjM1MDFDMzUuODgwNCA0Mi4zNTU5IDM3LjE4MDIgNDAuNDE3NiAzNy41NDQyIDM3LjMzNzlMMzkuOTMwNyAyNS45NDUxQzM5Ljk2NTMgMjUuNjY1MSA0MCAyNS4zMjA1IDQwIDI1LjEyNjdDNDAgMjQuMDkyOSAzOS4zNzYxIDIzLjM4MjIgMzguNDIyOSAyMy4zODIySDEwLjEyMTNMOS43OTIwMyAyMC42NDcxQzkuNjE4NzIgMTguOTg4OCA5LjEzMzQ1IDE4LjE0ODkgNy4zNjU2OCAxOC4xNDg5SDEuMjgyNUMwLjU4OTI1NSAxOC4xNDg5IDAgMTguOTAyNiAwIDE5Ljc2NDFDMCAyMC42NDcxIDAuNTg5MjU1IDIxLjQwMDkgMS4yODI1IDIxLjQwMDlINy4xNDAzOEw5LjkxMzM1IDQ1LjA0NzlDMTAuMjc3MyA0OC4xMDYxIDExLjU3NzEgNTAuMDIyOSAxNC4wOTAxIDUwLjAyMjlaTTM3LjA1MzcgMjYuNjM0MkwzNC44MjMyIDM2Ljk1MDJDMzQuNjg0NiAzOC4yODU1IDM0LjExMjcgMzkuMTAzOSAzMy4wOTAxIDM5LjEwMzlMMTEuOTc1NyAzOS4xMjU0TDEwLjUwMjYgMjYuNjM0MkgzNy4wNTM3WiIgZmlsbD0iIzUyNTM3NiIvPgo8Y2lyY2xlIGN4PSIyOS41IiBjeT0iNTAuNjQ4OSIgcj0iMi4yNSIgZmlsbD0id2hpdGUiIHN0cm9rZT0iIzUyNTM3NiIgc3Ryb2tlLXdpZHRoPSIyLjUiLz4KPGNpcmNsZSBjeD0iMTguNSIgY3k9IjUwLjY0ODkiIHI9IjIuMjUiIGZpbGw9IndoaXRlIiBzdHJva2U9IiM1MjUzNzYiIHN0cm9rZS13aWR0aD0iMi41Ii8+Cjwvc3ZnPgo=";
export { SvgProductPages as ReactComponent };